import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { validateError } from "../helpers/validateError";

export function useThunk(thunk) {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const runThunk = useCallback(
        async (arg) => {            
            setIsLoading(true);
            setError(null);
            try {
                const response = await dispatch(thunk(arg)).unwrap();
                return { success: true, response: response };
            } catch (err) {
                // const errorCode = err.code || DEFAULT_ERROR.code;
                // const errorCode = err.code || 500;
                // Check if the error code exists in ERROR_CODES
                // if (!ERROR_CODES[errorCode]) {
                //   navigate('/500');
                //   return {
                //     success: false,
                //     error: {
                //       code: errorCode,
                //       message: DEFAULT_ERROR.message,
                //     },
                //   };
                // }

                // const errorMessage = ERROR_CODES[errorCode]
                //   ? err.message || ERROR_CODES[errorCode]
                //   : DEFAULT_ERROR.message;

                const errorCode = err.code || 500;
                const errorMessage = err.message || 'Internal Server Error';

                const validatedError = {
                    code: errorCode,
                    message: errorMessage,
                };

                setError(validatedError);

                if(err.code === 500 || err.code === '500')
                {
                    navigate("/server-error");
                    return { success: false, error: validatedError };
                }

                return { success: false, error: validatedError };
            } finally {
                setIsLoading(false);
            }
        },
        [dispatch, thunk, navigate]
    );

    return [runThunk, isLoading, error];
}
